export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  height: '100%',
  padding: '24px',
  overflow: 'auto',
};
